interface ErrorMessageProps {
  message: string | null
}

export function ErrorMessage(props: ErrorMessageProps) {
  const { message } = props

  if (!message) return null

  return <p className="color-danger text-body font-medium">{message}</p>
}
